const links = document.querySelectorAll('.carousel__img');
const iframe = document.getElementById('youtube_iframe');
for (let i = 0; i < links.length; i++) {
  links[i].addEventListener('click', function (e) {
    let link = e.target.src;
    let id = link.substr(link.indexOf('/vi/') + 4, 11);

    for (let i = 0; i < links.length; i++) {
      links[i].classList.remove('carousel__img--active');
    }
    e.target.classList.add('carousel__img--active');
    iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1`;
  });
}
